@if (!minimalStyles) {
    <vc-chips-autocomplete-with-groups
        #chipsAutocompleteWithGroups
        [label]="label"
        [required]="required"
        [readonly]="readonly"
        [disabled]="disabled"
        [optionGroups]="tags"
        [optionRenderer]="tagRenderer"
        [prefixIconRenderer]="chipIconRenderer"
        [minimalStyles]="false"
        [description]="showAddDescription ? descriptionText : null"
        [allowAddNew]="allowAddNew"
        [canDeleteChip]="true"
        [removeHandler]="removeHandler"
        [addNewLabel]="addNewTagText"
        [tooltipOptionRenderer]="tooltipOptionRenderer"
        [(values)]="values"
        (addNew)="addNewTag($event)"
        (removeItem)="removeTag($event)"></vc-chips-autocomplete-with-groups>
} @else {
    <vc-multi-select-with-groups
        [label]="'COMMON_UI.TAGS' | transloco"
        suffixIcon="filter_alt_outline"
        [required]="required"
        [readonly]="readonly"
        [disabled]="disabled"
        [optionRenderer]="tagRenderer"
        [options]="tags"
        [minimalStyles]="true"
        [tooltipOptionRenderer]="tooltipOptionRenderer"
        [showClear]="true"
        [(values)]="keyValues"></vc-multi-select-with-groups>
}
